import { handleRovingKeyDown, rovingIndexFor } from '@/lib/roving-focus.js';

interface TermChipRowProps {
  /** Month values to render as "N mo" chips. */
  options: readonly number[];
  selected: number;
  onSelect: (value: number) => void;
  ariaLabel: string;
}

/** Shared by the product card and payment card; the marketplace analog is `OptionList`. */
export function TermChipRow({ options, selected, onSelect, ariaLabel }: TermChipRowProps) {
  const rovingIndex = rovingIndexFor(options, selected);

  return (
    <div className="sm-chat-product-term-row" role="radiogroup" aria-label={ariaLabel}>
      {options.map((value, index) => (
        <button
          key={value}
          type="button"
          className="sm-control sm-chip sm-tabular sm-chat-product-term-chip"
          role="radio"
          aria-checked={value === selected}
          tabIndex={index === rovingIndex ? 0 : -1}
          onKeyDown={(e) => handleRovingKeyDown(e, options, index, onSelect)}
          onClick={() => onSelect(value)}
        >
          {value} mo
        </button>
      ))}
    </div>
  );
}
